import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, RoleGuard, AuthRoutingModule, MainComponent } from 'ahm-angular';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'home', loadChildren: () => import('./source/pages/home/home.module')
          .then(m => m.HomeModule), canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: 'profile', loadChildren: () => import('./source/pages/profile/profile.module')
          .then(m => m.ProfileModule), canActivate: [AuthGuard, RoleGuard]
      },
      // {
      //   path: 'new-rate', loadChildren: () => import('./source/pages/newRate/newRate.module')
      //     .then(m => m.NewRateModule), canActivate: [AuthGuard, RoleGuard]
      // },
      // {
      //   path: 'offers', loadChildren: () => import('./source/pages/offers/offers.module')
      //     .then(m => m.OffersModule), canActivate: [AuthGuard, RoleGuard]
      // },
      { path: '**', redirectTo: '/not-found' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes), AuthRoutingModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
